export default "__VITE_ASSET__lBxTODIN__"